import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonIcon } from '@ionic/react';
import formats from '../../utils/formats';
import { close } from "ionicons/icons";

export default function LoginSuggestion(props) {
    const { type, id } = props;

    const { t } = useTranslation();

    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        let timeout = setTimeout(() => {
            setShow(true)
        }, 1000);

        return () => { clearTimeout(timeout) }
    }, []);

    return show ?
        <div className="login-suggestion mb-4">
            <div className="w-full mb-4 p-2 rounded-lg border border-slate-300">
                <div className="mb-2 flex justify-between items-center">
                    <span className="py-1 px-2 rounded-full text-sm bg-mycia-red text-white">{t("loginsuggestion.span_1")}</span>

                    <button className="cursor-pointer flex items-center" onClick={() => setShow(false)}>
                        <IonIcon slot="icon-only" icon={close}></IonIcon>
                    </button>
                </div>

                <p className="text-sm text-center">{t("loginsuggestion.p_1.fragment_1")} <span className="underline font-bold">{t("loginsuggestion.p_1.fragment_2")}</span> {t("loginsuggestion.p_1.fragment_3")}.</p>
            </div>

            <div className="cursor-pointer p-1 rounded-md bg-slate-100">
                <div className="w-full flex justify-center items-center">
                    <div className="flex-1 py-2 rounded-md font-bold text-sm text-center bg-gray-300 text-black">{t("loginsuggestion.div_1")}</div>
                    <a href={formats.loginUrl(type, id)} className="flex-1 py-2 rounded-md font-bold text-center text-sm text-mycia-red">{t("loginsuggestion.link_1")}</a>
                </div>
            </div>
        </div> : null;
}
